import { render, staticRenderFns } from "./TocContainer.vue?vue&type=template&id=60f5f4ef"
import script from "./TocContainer.vue?vue&type=script&lang=js"
export * from "./TocContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports